import { combineReducers } from 'redux'
import misc from './misc'
import publicholidays from './publicholidays'

export default combineReducers({
  misc,
  publicholidays,
})
